import React, { useState } from 'react';
import { Settings as SettingsIcon, Users, Shield, Cog, Lock } from 'lucide-react';
import UsersPage from './UsersPage';
import RolesPage from './RolesPage';
import PermissionsPage from './PermissionsPage';
import SystemConfigPage from './SystemConfigPage';

type TabType = 'users' | 'roles' | 'permissions' | 'system';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('users');

  const tabs = [
    {
      id: 'users' as TabType,
      label: 'Usuários',
      icon: Users,
      component: UsersPage,
    },
    {
      id: 'roles' as TabType,
      label: 'Perfis de Acesso',
      icon: Shield,
      component: RolesPage,
    },
    {
      id: 'permissions' as TabType,
      label: 'Permissões',
      icon: Lock,
      component: PermissionsPage,
    },
    {
      id: 'system' as TabType,
      label: 'Configurações do Sistema',
      icon: Cog,
      component: SystemConfigPage,
    },
  ];

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 rounded-lg">
              <SettingsIcon className="h-6 w-6 text-blue-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">
              Configurações e Administração
            </h1>
          </div>
          <p className="text-gray-600 ml-14">
            Gerencie usuários, perfis de acesso e configurações do sistema
          </p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px" aria-label="Tabs">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;

                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors
                      ${
                        isActive
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                  >
                    <Icon className="h-5 w-5" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </div>
  );
};

export default Settings;
